<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12" lg="6">
                <label>Cliente</label>
                <app-autocomplete
                    placeholder="Cliente"
                    :items="clients"
                    v-model="selectedClient"
                />
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-select-input
                    :disabled="!selectedClient"
                    label="Sub-Cliente"
                    :options="clientCustomers"
                    v-model="selectedClientCustomer"
                />
            </b-col>
            <b-col cols="12" lg="6">
                <app-date-time-picker
                    :withTime="false"
                    label="Fecha inicio"
                    v-model="theService.startDate"
                    :required="true"
                    :hasError="$v.theService.startDate.$error"
                    error-message="Debe especificar la fecha"
                    :max-date="moment().toDate()"
                />
            </b-col>
            <b-col cols="12" lg="6" v-if="other">
                <app-form-text-input
                    label="Ingrese otro Sub-Cliente:"
                    id="otherSubClient"
                    v-model="theService.otherSubClient"
                />
            </b-col>
            <b-col cols="12" lg="6">
                <label>
                    Hora de inicio
                    <span class="field-required-mark">*</span>
                </label>
                <b-form-input
                    id="time"
                    type="time"
                    @change="$v.theService.startHour.$touch()"
                    v-model="theService.startHour"
                ></b-form-input>
                <span class="field-error" v-if="$v.theService.startHour.$error"
                    >Debe especificar la hora</span
                >
            </b-col>
            <b-col cols="12" lg="6" v-if="!!service">
                <app-date-time-picker
                    :withTime="false"
                    label="Fecha Fin"
                    v-model="theService.endDate"
                    :required="true"
                    :hasError="$v.theService.endDate.$error"
                    error-message="Debe especificar la fecha"
                    :max-date="moment().toDate()"
                />
            </b-col>
            <b-col cols="12" lg="6" v-if="!!service">
                <label>
                    Hora de finalización
                    <span class="field-required-mark">*</span>
                </label>
                <b-form-input
                    id="time"
                    type="time"
                    @change="$v.theService.endHour.$touch()"
                    v-model="theService.endHour"
                ></b-form-input>
                <span class="field-error" v-if="$v.theService.endHour.$error"
                    >Debe especificar la hora</span
                >
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-text-input
                    label="Placa del vehículo"
                    id="plateDocument"
                    :required="true"
                    :hasError="$v.theService.plateDocument.$error"
                    errorMessage="Debe escribir la placa"
                    @input="$v.theService.plateDocument.$touch()"
                    v-model="theService.plateDocument"
                    :input-classes="{ 'plate-input': true }"
                />
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-text-input
                    label="Nombre conductor"
                    id="personName"
                    :required="true"
                    :hasError="$v.theService.personName.$error"
                    errorMessage="Debe escribir el nombre del conductor"
                    @input="$v.theService.personName.$touch()"
                    v-model="theService.personName"
                />
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-select-input
                    label="Ciudad Servicio"
                    id="city-service"
                    :required="true"
                    :has-error="$v.theService.cityId.$error"
                    @change="onChangeCity"
                    error-message="Debe seleccionar la ciudad donde se presta el servicio"
                    v-model="theService.cityId"
                    :options="cities"
                />
            </b-col>
            <b-col cols="12" lg="6">
                <b-form-checkbox
                    v-model="theService.cityOutside"
                    name="check-button"
                    switch
                    value="yes"
                    unchecked-value="no"
                    >Fuera de la ciudad</b-form-checkbox
                >
            </b-col>
            <b-col cols="12" lg="6" v-if="theService.cityOutside === 'yes'">
                <app-form-select-input
                    label="Lugar del servicio"
                    id="town-service"
                    :required="towns.length > 0"
                    :has-error="$v.theService.cityId.$error"
                    error-message="Debe seleccionar la ciudad donde se presta el servicio"
                    v-model="theService.townId"
                    :options="theTowns"
                />
            </b-col>
            <b-col cols="12" lg="6" v-if="theService.townId === -1">
                <app-form-text-input
                    label="Lugar"
                    v-model="theService.otherTown"
                    :required="true"
                    :has-error="$v.theService.otherTown.$error"
                    error-message="Debe especificar el lugar"
                    @input="$v.theService.otherTown.$touch()"
                />
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { required, requiredIf } from 'vuelidate/lib/validators'
import Autocomplete from '@components/UI/Controls/AutocompleteV2/Autocomplete.vue'
import clientsRepository from '@repositories/clients.repository.js'
import { mapGetters, mapMutations } from 'vuex'
import bodyguardRepository from '@repositories/bodyguard.repository'
import * as mutations from '@store/commitTypes'

// import ImageTools from '@utils/ImageTools';
export default {
    name: 'bodyguard_service_form_vehicular',
    components: {
        appAutocomplete: Autocomplete,
    },
    props: {
        bodyguardPhoto: {
            type: String,
            required: () => !this.service,
        },
        gunPhotos: {
            type: Array,
            required: () => !this.service,
        },
        latitude: {
            type: String,
            default: '',
        },
        longitude: {
            type: String,
            default: '',
        },
        service: {
            type: Object,
            default: null,
        },
        onSave: {
            type: Function,
        },
    },
    data: () => ({
        newSubClient: false,
        other: false,
        selectedClient: '',
        selectedClientCustomer: '',
        theService: {
            clientCustomerId: '',
            startDate: '',
            startHour: '',
            endDate: '',
            endHour: '',
            plateDocument: '',
            personName: '',
            cityId: '',
            townId: '',
            cityOutside: 'no',
            otherTown: '',
            otherSubClient: '',
        },
        clients: [],
        clientCustomers: [],
        towns: [],
    }),
    watch: {
        selectedClient(client) {
            this.$v.theService.clientId.$touch()
            if (!!client) {
                this.theService.clientId = client.id
                this.loadClientCustomers(client.id)
            } else {
                this.theService.clientId = ''
                this.theService.clientCustomerId = ''
                this.clientCustomers = []
            }
        },
        service(service) {
            if (!service) return this.clearForm()

            this.initialize()
        },
        selectedClientCustomer(id) {
            if (id === -1) {
                this.theService.clientCustomerId = id
                this.other = true
            } else {
                this.other = false
                this.theService.clientCustomerId = id
            }
        },
    },
    validations() {
        const validators = {
            selectedClient: { required },
            theService: {
                clientId: { required },
                startDate: { required },
                startHour: { required },
                endDate: !!this.service ? { required } : {},
                endHour: !!this.service ? { required } : {},
                plateDocument: { required },
                personName: { required },
                cityId: { required },
                clientCustomerId: { required },
                townId: {
                    required: requiredIf(function() {
                        return this.theService.cityOutside === 'yes'
                    }),
                },
                otherTown: {
                    required: requiredIf(function() {
                        return this.theService.townId === -1
                    }),
                },
                otherSubClient: {
                    required: requiredIf(function() {
                        return this.theService.clientCustomerId === -1
                    }),
                },
            },
        }

        return validators
    },
    computed: {
        ...mapGetters(['cities']),
        theTowns() {
            const towns = this.towns.slice(0)
            towns.push({ id: -1, name: 'Otro' })
            return towns
        },
        updating() {
            return !!this.service
        },
    },
    methods: {
        ...mapMutations({
            setCurrentService: mutations.SET_SELECTED_BODYGUARD_SERVICE,
        }),
        async loadClients() {
            const cr = { ...clientsRepository }
            const filters = { module_slug: 'escoltas' }
            try {
                const data = await cr.getClientsOptionalModule(filters)
                this.clients = data

                if (!!this.service) {
                    const client = this.clients.find(
                        item => item.id === this.service.client_id
                    )
                    !!client && (this.selectedClient = client)
                }
            } catch (err) {
                toastr.error(`Error al cargar los clientes [${err.message}]`)
            }
        },
        async loadClientCustomers(clientId) {
            const cr = { ...clientsRepository }
            try {
                const data = await cr.getClientCustomers({ client: clientId })
                this.clientCustomers = data
                this.clientCustomers.push({ id: -1, name: 'Otro' })
                this.theService.clientCustomerId =
                    data.length === 1 ? data[0].id : ''

                if (this.updating) {
                    this.selectedClientCustomer = this.service.client_customer_id
                }
            } catch (err) {
                toastr.error(
                    `Ocurrió un error al cargar los clientes [${err.message}]`
                )
            }
        },
        setAutoDateTime() {
            this.theService.startDate = moment().format('YYYY-MM-DD')
            this.theService.startHour = moment().format('HH:mm')
        },
        async loadTowns(cityId) {
            const cr = { ...clientsRepository }

            try {
                const { data } = await cr.getTowns({ city: cityId })
                this.towns = data

                if (this.updating) {
                    this.theService.townId = this.service.town_id
                }
            } catch (err) {
                toastr.error(
                    `Ocurrió un error al cargar los lugares [${err.message}]`
                )
            }
        },
        onChangeCity(cityId) {
            this.$v.theService.cityId.$touch()
            this.loadTowns(cityId)
        },
        setAutoCity() {
            this.theService.cityId = this.user.city.id
        },
        initialize() {
            this.loadClients()
            this.load('cities').then(results => {
                if (this.updating) {
                    this.theService.cityId = this.service.city_id
                }
            })

            if (!this.updating) {
                this.setAutoDateTime()
                this.setAutoCity()
            } else {
                this.fillForm()
            }
        },
        fillForm() {
            // this.loadTowns(this.service.city_id);
            this.theService.startDate = moment(this.service.start_date).format(
                'YYYY-MM-DD'
            )
            this.theService.startHour = moment(this.service.start_date).format(
                'HH:mm'
            )
            this.theService.endDate = moment(this.service.end_date).format(
                'YYYY-MM-DD'
            )
            this.theService.endHour = moment(this.service.end_date).format(
                'HH:mm'
            )
            this.theService.plateDocument = this.service.plate_document
            this.theService.personName = this.service.driver_person_name

            this.theService.cityOutside = !!this.service.out_of_city
                ? 'yes'
                : 'no'
        },
        async saveService() {
            if (this.updating) {
                await this.updateService()
            } else {
                await this.createService()
            }
            typeof this.onSave === 'function' && this.onSave()
        },
        async createService() {
            this.$v.$touch()
            if (this.$v.$invalid)
                return toastr.error('Debe diligenciar todos los campos')

            const formData = new FormData()
            Object.keys(this.theService).forEach(key =>
                formData.append(key, this.theService[key])
            )
            formData.append('userId', this.user.id)
            formData.append('serviceType', 'vehicular')
            formData.append('latitude', this.latitude)
            formData.append('longitude', this.longitude)
            formData.append('bodyguardPhoto', this.bodyguardPhoto)
            this.gunPhotos.forEach(photo =>
                formData.append('gunPhotos[]', photo)
            )

            const br = { ...bodyguardRepository }

            try {
                const {
                    data: { status, msg, service },
                } = await br.saveBodyguardService(formData)

                if (status) {
                    this.setCurrentService(service)
                    toastr.success('Servicio iniciado correctamente')
                    this.$bus.$emit('bodyguard-service-form.close')
                    this.clearForm()
                    this.$router.push({ name: 'activeBodyguardServicePage' })
                } else {
                    toastr.error(msg)
                }
            } catch (err) {
                this.handleErrors(err)
            } finally {
            }
        },
        async updateService() {
            if (this.theService.clientCustomerId === '') {
                return toastr.error('Debe seleccionar un Sub-Cliente')
            }
            if (this.theService.clientCustomerId === -1) {
                if (this.theService.otherSubClient === '') {
                    return toastr.error(
                        'debe ingresar el nombre del otro Sub-Cliente'
                    )
                }
            }
            const br = { ...bodyguardRepository }

            try {
                const { data } = await br.updateBodyguardService(
                    this.theService,
                    this.service.id
                )

                if (data.status) {
                    toastr.success(data.msg)
                    this.$emit('service-saved', data)
                } else {
                    toastr.error(data.msg)
                }
            } catch (err) {
                this.handleErrors(err)
            }
        },
        clearForm() {
            this.selectedClient = ''
            Object.keys(this.theService).map(key => (this.theService[key] = ''))
            this.theService.cityOutside = false
            this.$v.$reset()
        },
    },
    created() {
        this.initialize()
        this.$bus.$on('bodyguard-service-vehicular.save', this.saveService)
        this.$bus.$on(
            'appBodyguardServiceFormVehicular.clearForm',
            this.clearForm
        )
    },
    mounted() {},
}
</script>
